module.exports = __webpack_public_path__ + "img/tenglong02.620f8dae.png";